import React from "react";
import Chip from "@material-ui/core/Chip";

export default class extends React.Component {
  render() {
    let { label, color, title, style } = this.props;
    label = parseFloat(label).toFixed(2);

    return <Chip label={label} color={color} title={title} style={style} />;
  }
}
